module.exports = __webpack_public_path__ + "img/img7.5bef6f4b.png";